
export const HAS_PROPERTY = "HP";
export const HAS_PROPERTY_WITH_VALUE = "HPV";
export const DOES_NOT_HAVE_PROPERTY = "DNHP";
export const DOES_NOT_HAVE_PROPERTY_WITH_VALUE = "DNHPV";
